import { useTranslation } from 'react-i18next';

export function SignedOutPage({ loginUrl }: { loginUrl: string }) {
  const { t } = useTranslation();
  const reason = new URLSearchParams(window.location.search).get('reason');

  return (
    <div className="centered-page">
      <div className="centered-card">
        <h1>{t('auth.signedOutTitle')}</h1>
        <p>{reason === 'provider_error' ? t('auth.providerError') : t('auth.signedOutBody')}</p>
        {/*
          A link, not a fetch: the sign-in flow is a browser navigation to the
          identity provider and back. Starting it with XHR would strand the
          redirect inside the request.
        */}
        <a className="button button--primary" href={loginUrl}>
          {t('app.signIn')}
        </a>
      </div>
    </div>
  );
}
